/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The slug types for account notifications
 */
export enum AccountNotificationSlugType {
  community_post_reply = "community_post_reply",
}

/**
 * Possible Event Status types
 */
export enum EventStatusTypes {
  EXPIRED = "EXPIRED",
  UPCOMING = "UPCOMING",
}

/**
 * Possible directions in which to order a list of items when provided an orderBy argument
 */
export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * The type of the post attachment
 */
export enum PostAttachmentType {
  file = "file",
  image = "image",
  video = "video",
}

/**
 * Possible fields to order posts
 */
export enum PostOrderField {
  CONTENT_NAME = "CONTENT_NAME",
  COURSE_NAME = "COURSE_NAME",
  CREATED_AT = "CREATED_AT",
  LAST_INTERACTION_AT = "LAST_INTERACTION_AT",
  PINNED_AT = "PINNED_AT",
  REPLY_COUNT = "REPLY_COUNT",
  TITLE = "TITLE",
  TRENDING_SCORE = "TRENDING_SCORE",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * The type of the post reaction
 */
export enum PostReactionType {
  like = "like",
}

/**
 * Autogenerated input type of CreateAttendance
 */
export interface CreateAttendanceInput {
  clientMutationId?: string | null;
  eventId: string;
}

/**
 * Autogenerated input type of CreateCommunitySpace
 */
export interface CreateCommunitySpaceInput {
  clientMutationId?: string | null;
  communitySectionId: string;
  description: string;
  iconName?: string | null;
  image?: ImageInput | null;
  isExclusive?: boolean | null;
  memberIds?: string[] | null;
  name: string;
  relatedProductId?: string | null;
}

/**
 * Autogenerated input type of CreateLiveEvent
 */
export interface CreateLiveEventInput {
  clientMutationId?: string | null;
  description: string;
  endTime: any;
  eventSourceId: string;
  eventSourceType: string;
  image?: EventImageInput | null;
  location?: string | null;
  meetingUrl?: any | null;
  sendEmails?: boolean | null;
  startTime: any;
  timezone: string;
  title: string;
}

/**
 * Autogenerated input type of DeleteAttendance
 */
export interface DeleteAttendanceInput {
  clientMutationId?: string | null;
  eventId: string;
}

/**
 * Autogenerated input type of DeleteCommunitySpace
 */
export interface DeleteCommunitySpaceInput {
  clientMutationId?: string | null;
  id: string;
}

/**
 * Autogenerated input type of DeleteLiveEvent
 */
export interface DeleteLiveEventInput {
  clientMutationId?: string | null;
  id: string;
  sendEmails?: boolean | null;
}

/**
 * Autogenerated input type of DuplicateLiveEvent
 */
export interface DuplicateLiveEventInput {
  clientMutationId?: string | null;
  description?: string | null;
  endTime?: any | null;
  eventId: string;
  image?: EventImageInput | null;
  location?: string | null;
  meetingUrl?: any | null;
  sendEmails?: boolean | null;
  startTime?: any | null;
  timezone?: string | null;
  title?: string | null;
}

/**
 * Autogenerated input type of EditPost
 */
export interface EditPostInput {
  clientMutationId?: string | null;
  communitySpaceId?: string | null;
  content?: string | null;
  id: string;
  mentionedUserIds?: string[] | null;
  postAttachmentInput?: PostAttachmentInput | null;
  title?: string | null;
}

/**
 * Autogenerated input type of EditReply
 */
export interface EditReplyInput {
  clientMutationId?: string | null;
  content?: string | null;
  id: string;
  mentionedUserIds?: string[] | null;
  postAttachmentInput?: PostAttachmentInput | null;
}

/**
 * Shared Image input fields
 */
export interface EventImageInput {
  altText?: string | null;
  bucket?: string | null;
  key?: string | null;
  uploadId?: string | null;
}

/**
 * Shared Image imput fields
 */
export interface ImageInput {
  altText?: string | null;
  bucket?: string | null;
  key?: string | null;
  uploadId?: string | null;
}

/**
 * Input fields for a post attachment
 */
export interface PostAttachmentInput {
  altText?: string | null;
  attachmentType: PostAttachmentType;
  attachmentUrl?: string | null;
  fileName?: string | null;
  fileSizeInBytes?: number | null;
  filestackId?: string | null;
  s3Bucket?: string | null;
  s3Key?: string | null;
}

/**
 * Possible fields to filter posts
 */
export interface PostFilter {
  communitySpaceId?: string | null;
  following?: boolean | null;
  trending?: boolean | null;
  userId?: string | null;
}

/**
 * Autogenerated input type of ReorderCommunitySpace
 */
export interface ReorderCommunitySpaceInput {
  clientMutationId?: string | null;
  id: string;
  position: any;
}

/**
 * Autogenerated input type of UpdateAccountNotification
 */
export interface UpdateAccountNotificationInput {
  clientMutationId?: string | null;
  isEnabled: boolean;
  slug?: AccountNotificationSlugType | null;
}

/**
 * Autogenerated input type of UpdateCommunitySpace
 */
export interface UpdateCommunitySpaceInput {
  clientMutationId?: string | null;
  description?: string | null;
  iconName?: string | null;
  id: string;
  image?: ImageInput | null;
  name?: string | null;
  relatedProductId?: string | null;
}

/**
 * Autogenerated input type of UpdateLiveEvent
 */
export interface UpdateLiveEventInput {
  clientMutationId?: string | null;
  description?: string | null;
  endTime: any;
  id: string;
  image?: EventImageInput | null;
  location?: string | null;
  meetingUrl?: any | null;
  sendEmails?: boolean | null;
  startTime: any;
  timezone?: string | null;
  title?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
